// extracted by mini-css-extract-plugin
export var fadeIn = "_hs-1";
export var modalContent = "_hs-3";
export var overlay = "_hs-0";
export var popoverContent = "_hs-2";
export var results = "_hs-5";
export var searchInputWrapper = "_hs-4";